import { Component } from "solid-js";

export const PanelHeader: Component<{ title: string }> = (props) => (
  <h2 class="ml-1 text-lg font-semibold">{props.title}</h2>
);
